<ng-container *ngIf="controller?.state$ | async as s">
  <ng-container *ngIf="state(!!s.loading, s.mode === 'playback') as st">

    <!-- The cost is stated ON the control, so it is read before the click rather
         than after it in a popup. `type="button"` matters: this renders inside a
         mat-expansion-panel-header, where a default submit button would be a
         second way to toggle the panel. -->
    <!-- No count inside the control, deliberately: a trailing number is the
         strongest badge signal there is, and this panel spells every counter as
         a pill. The balance lives on the Refresh History header — the section
         that spends it. `type="button"` matters: this renders inside a
         mat-expansion-panel-header, where a default submit button would be a
         second way to toggle the panel. -->
    <button type="button" class="vr-refresh"
            [ngClass]="'is-' + st.kind"
            [disabled]="st.disabled"
            [attr.aria-label]="st.label"
            [matTooltip]="st.tooltip"
            matTooltipPosition="above"
            (click)="onClick($event, st)">
      <mat-icon class="material-icons-outlined vr-refresh__icon"
                *ngIf="st.kind !== 'exhausted' && st.kind !== 'expired' && st.kind !== 'not-started'"
                [class.is-spinning]="st.kind === 'loading'">
        {{ st.kind === 'loading' ? 'autorenew' : 'refresh' }}
      </mat-icon>
      <span class="vr-refresh__label">{{ st.label }}</span>
    </button>

  </ng-container>
</ng-container>
